import depo from '../services/depo'; // GF1: try/catch'li localStorage sarmalayıcısı (3. taraf iframe)
import AuthService from '../services/auth.service';

const user = JSON.parse(depo.oku('user'));
const initialState = user
  ? { status: { loggedIn: true }, user }
  : { status: { loggedIn: false }, user: null };

export const auth = {
  namespaced: true,
  state: initialState,
  actions: {
    login({ commit }, user) {
      return AuthService.login(user).then(
        user => {
          commit('loginSuccess', user);          
          return Promise.resolve(user);
        },
        error => {
          commit('loginFailure');
          return Promise.reject(error);
        }
      );
    },
    googleLogin({ commit }, idToken) {
      return AuthService.googleLogin(idToken).then(
        user => {
          commit('loginSuccess', user);
          return Promise.resolve(user);
        },
        error => {
          commit('loginFailure');
          return Promise.reject(error);
        }
      );
    },
    logout({ commit }) {
      AuthService.logout();
      commit('logout');
    },
    // Kullanilmiyor — router beforeEach guard ayni kontrolu yapiyor
    // checkTokenValidity({ commit }) {
    //   if (AuthService.isTokenExpired()) {
    //     commit('logout');
    //     depo.sil('user');
    //     depo.sil('token');
    //     depo.sil('tokenExpiration');
    //     depo.sil('refreshToken');
    //     return false;
    //   }
    //   return true;
    // },
  },
  mutations: {
    loginSuccess(state, user) {
      state.status.loggedIn = true;
      state.user = user;
    },
    loginFailure(state) {
      state.status.loggedIn = false;
      state.user = null;
    },
    logout(state) {
      state.status.loggedIn = false;
      state.user = null;
    },
  }
};